export default "__VITE_ASSET__DjOE21Vs__"